import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  OnInit,
  OnDestroy,
  ViewChild,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApiService } from '../../shared/services/api.service';
import { LoaderService } from '../../shared/services/loader.service';

@Component({
  selector: 'app-customer-feedback',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './customer-feedback.component.html',
  styleUrl: './customer-feedback.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerFeedbackComponent implements OnInit, OnDestroy {
  @ViewChild('testimonialList') testimonialList: ElementRef | undefined;

  // Carousel configuration
  currentSlide = 0;
  visibleSlides = 1;
  private readonly SCROLL_AMOUNT = 450;

  // Testimonials data
  testimonials: any[] = [
    {
      comment:
        'This platform makes finding spare parts so easy! Great selection, fast delivery, competitive prices, and excellent support. Highly recommended!',
      user__first_name: 'Onkarpreet Singh',
      user__last_name: 'Kapoor',
      designation: 'Mechanic',
      company: 'Kapoor Automotives',
      rating: 4,
    },
    {
      comment:
        'This platform makes finding spare parts so easy! Great selection, fast delivery, competitive prices, and excellent support. Highly recommended!',
      user__first_name: 'Onkarpreet Singh',
      user__last_name: 'Kapoor',
      designation: 'Mechanic',
      company: 'Kapoor Automotives',
      rating: 5,
    },
    {
      comment:
        'This platform makes finding spare parts so easy! Great selection, fast delivery, competitive prices, and excellent support. Highly recommended!',
      user__first_name: 'Onkarpreet Singh',
      user__last_name: 'Kapoor',
      designation: 'Mechanic',
      company: 'Kapoor Automotives',
      rating: 4,
    },
  ];

  private destroy$ = new Subject<void>();

  constructor(
    private feedback: ApiService,
    private loader: LoaderService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    // Uncomment to load feedback from API
    // this.custFeedback();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  scrollLeft(): void {
    this.scrollCarousel(-this.SCROLL_AMOUNT);
    if (this.currentSlide > 0) {
      this.currentSlide--;
    }
  }

  scrollRight(): void {
    this.scrollCarousel(this.SCROLL_AMOUNT);
    if (this.currentSlide < this.testimonials.length - this.visibleSlides) {
      this.currentSlide++;
    }
  }

  next(): void {
    if (this.currentSlide < this.testimonials.length - this.visibleSlides) {
      this.scrollCarousel(this.SCROLL_AMOUNT);
      this.currentSlide++;
    }
  }

  prev(): void {
    if (this.currentSlide > 0) {
      this.scrollCarousel(-this.SCROLL_AMOUNT);
      this.currentSlide--;
    }
  }

  /**
   * Centralized scroll logic to avoid duplication
   */
  private scrollCarousel(amount: number): void {
    if (this.testimonialList) {
      const element = this.testimonialList.nativeElement;
      element.scrollBy({ left: amount, behavior: 'smooth' });
    }
  }

  /**
   * Load customer feedback from API
   */
  custFeedback(): void {
    try {
      const payload = {};

      this.loader.show();

      this.feedback
        .customerFeddback(payload)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (value) => {
            this.loader.hide();
            if (value.success && value.data) {
              this.testimonials = value.data;
              this.cdr.markForCheck();
              console.log('Feedback loaded:', this.testimonials);
            } else {
              console.warn('Customer feedback API returned success: false');
              this.testimonials = [];
              this.cdr.markForCheck();
            }
          },
          error: (err) => {
            this.loader.hide();
            console.error('Error loading feedback:', err);
            this.testimonials = [];
            this.cdr.markForCheck();
          },
        });
    } catch (error) {
      this.loader.hide();
      console.error('Error in customer feedback:', error);
      this.testimonials = [];
      this.cdr.markForCheck();
    }
  }

  /**
   * TrackBy function for testimonials list
   */
  trackByTestimonial(index: number, testimonial: any): any {
    return testimonial.id || index;
  }
}
